const API_BASE = process.env.REACT_APP_API_URL ; // Ensure no duplicate /api

console.log(API_BASE);


export const API_ENDPOINTS = {

  // Auth
  token: `${API_BASE}/api/token/`,
  refreshToken: `${API_BASE}/api/token/refresh/`,
  activateAccountByToken: `${API_BASE}/api/auth/activate/`,
  changePasswordByToken: `${API_BASE}/api/auth/reset-password/`,
  forgotPassword: `${API_BASE}/api/auth/request-password-reset/`,
  changePassword: `${API_BASE}/api/auth/change-password/`,
  brandingLogo: `${API_BASE}/api/auth/branding/`,
  userDetail: `${API_BASE}/api/auth/user/userdetail/`,

  // MFA
  mfaStatus: `${API_BASE}/api/auth/mfa/status/`,
  mfaSetup: `${API_BASE}/api/auth/mfa/setup/`,
  mfaConfirm: `${API_BASE}/api/auth/mfa/confirm/`,
  mfaVerify: `${API_BASE}/api/auth/mfa/verify/`,
  mfaDisable: `${API_BASE}/api/auth/mfa/disable/`,
  mfaBackupCodes: `${API_BASE}/api/auth/mfa/backup-codes/`,
  mfaPolicy: `${API_BASE}/api/auth/mfa/policy/`,
  

  // Questionario
  questionarioCurrent: `${API_BASE}/api/questionari/questionario/current/`,
  questionarioDetail: (id) => `${API_BASE}/api/questionari/questionario/${id}/`,
  createQuestionario: `${API_BASE}/api/questionari/questionario/`,
  incompleteQuestions: (id) => `${API_BASE}/api/questionari/questionario/${id}/incomplete_questions/`,
  questionarioRisposte: (id) => `${API_BASE}/api/questionari/questionario/${id}/risposte/`,
  questionarioComplete: (id) => `${API_BASE}/api/questionari/questionario/${id}/complete/`,
  saveRisposta: (id) => `${API_BASE}/api/questionari/questionario/${id}/save_risposta/`,
  nis2Report: (id) => `${API_BASE}/api/questionari/questionario/${id}/nis2_report/`,
  allDomande: `${API_BASE}/api/questionari/questionario/domande/`,
  domandaDetail: (id) => `${API_BASE}/api/questionari/questionario/domande/${id}/`,
  opzioniRisposta: (domanda_id) => `${API_BASE}/questionari/questionario/domande/${domanda_id}/opzioni/`,
  allSezioni: `${API_BASE}/questionari/questionario/sezioni/`,

  // Assets
  allCompanyAssets: `${API_BASE}/api/assets/`,
  singleAsset: (id) => `${API_BASE}/api/assets/${id}/`,
  createNewAsset: `${API_BASE}/api/assets/`,
  updateAsset: (id) => `${API_BASE}/api/assets/${id}/`,
  deleteAsset: (id) => `${API_BASE}/api/assets/${id}/`,

  // Altri endpoint (che potrebbero avere URL diversi)
  aziendaDashboard: `${API_BASE}/api/aziende/dashboard/`,
  aziendaProfile: `${API_BASE}/aziende/me/`,
  codiciAttivazione: `${API_BASE}/aziende/codici-attivazione/`,
  manageEndpoints: `${API_BASE}/aziende/manage-endpoints/`,

  //CyberSurveillance
  // cyberSurveillance: `${API_BASE}/api/assets/cyber-angel/results/?force=true`,
  cyberSurveillance: `${API_BASE}/api/assets/cyber-angel/results/`,
  cyberSurveillanceStats: `${API_BASE}/api/assets/cyber-angel/stats/`,
  cyberSurveillanceVulnerability: `${API_BASE}/api/assets/cyber-angel/vulnerabilities/`,
  changeStatusVulnerability: (id) => `${API_BASE}/api/assets/cyber-angel/vulnerabilities/${id}/status/`,
  changeStatusCredential: (id) => `${API_BASE}/api/assets/cyber-angel/breaches/${id}/status/`,
  listCredenzialiEsposte: `${API_BASE}/api/assets/cyber-angel/credentials/`,

  // Aziende
  aziendaDettagli: `${API_BASE}/api/aziende/me/`,
  aziendaInfo: `${API_BASE}/api/aziende/info/`,
  getSettori: `${API_BASE}/api/settori/`,
  setTipoAzienda: `${API_BASE}/api/aziende/info/`,

  // Ordini
  currentOrder: `${API_BASE}/api/ordini/current-order/`,

  // Endpoint module endpoints
  endpointList: `${API_BASE}/api/endpoint/endpoints/`,
  endpointStateUpdate: (id) => `${API_BASE}/api/endpoint/${id}/state/`,
  pluginActivation: `${API_BASE}/api/endpoint/plugin-activation/`,
  fileAngelData: `${API_BASE}/api/endpoint/fileangel/`,
  aziendaFileAngelData: `${API_BASE}/api/endpoint/azienda/fileangel/`,
  aziendaFileAngelStats: `${API_BASE}/api/endpoint/azienda/fileangel/stats/`,
  browsingAngelData: `${API_BASE}/api/endpoint/browsing/`,
  aziendaBrowsingAngelData: `${API_BASE}/api/endpoint/azienda/browsing/`,
  aziendaBrowsingAngelStats: `${API_BASE}/api/endpoint/azienda/browsing/stats/`,

  // MSSP
  listaAziendeMSSP: `${API_BASE}/api/mssp/portal/aziende/`,
  tokenSso: `${API_BASE}/api/sso/generate-token/`,
  creaTecnicoMSSP: `${API_BASE}/api/mssp/tecnici/`,
  listaTecniciMSSP: `${API_BASE}/api/mssp/tecnici/`,
  dettaglioTecnicoMSSP: (id) => `${API_BASE}/api/mssp/tecnici/${id}`,
  validaEmailTecnicoMSSP: `${API_BASE}/api/mssp/tecnici/validate/`,
  abilitaTecnicoMSSP: (id) => `${API_BASE}/api/mssp/tecnici/${id}/enable/`,
  disabilitaTecnicoMSSP: (id) => `${API_BASE}/api/mssp/tecnici/${id}/disable/`,
  cancellaTecnicoMSSP: (id) => `${API_BASE}/api/mssp/tecnici/${id}`,

  //Enterprise
  aziendeMonitorateEnriched: `${API_BASE}/api/enterprise/aziende-monitorate/enriched`,
  addCsvFile: `${API_BASE}/api/enterprise/bulk-import/`,
  aziendeCaricate: `${API_BASE}/api/enterprise/aziende-caricate/`,
  creaAzienda: `${API_BASE}/api/enterprise/aziende-caricate/`,
  cancellaAziendaCaricata: (id) => `${API_BASE}/api/enterprise/aziende-caricate/${id}/`,
  revocaMonitoraggio: (id) => `${API_BASE}/api/enterprise/aziende-monitorate/${id}/`,
  aggiornaParziale: (id) => `${API_BASE}/api/enterprise/aziende-caricate/${id}/`,
  aggiornaCompleto: (id) => `${API_BASE}/api/enterprise/aziende-caricate/${id}/`,
  statisticheAggregate: `${API_BASE}/api/enterprise/aziende-monitorate/stats/`,
  

  // ExportPDF
  exportPDF: `${API_BASE}/api/report/cyberlog/`,
  cyberlogTesti: `${API_BASE}/api/report/cyberlog/testi/`,

};

// Funzione utile per il debug durante lo sviluppo
export const debugAPIUrls = () => {
  console.log('API_BASE:', API_BASE);
  console.log('Examples:');
  console.log('- questionarioCurrent:', API_ENDPOINTS.questionarioCurrent);
  console.log('- questionarioDetail:', API_ENDPOINTS.questionarioDetail('test-id'));
  console.log('- questionarioRisposte:', API_ENDPOINTS.questionarioRisposte('test-id'));
  console.log('- allDomande:', API_ENDPOINTS.allDomande);
};

export default API_ENDPOINTS;